import React from 'react';
import { connect } from 'react-redux';
import TapIcon from '../../../services/TapIcon';
import Ax from '../../../components/hoc/Ax';
import HttpAPICall from '../../../services/HttpAPICall';
import Loader from '../../../components/ui/Loader/Loader';
import AppBaseComponent from '../../../components/AppBaseComponent';
import { toast } from 'react-toastify';
import swal from "sweetalert";
import { INVENTORY_API_BASE_URL_2, SCHEDULE_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import DateService from '../../../services/DateService';
import Status from '../../../components/ui/Status';
import { DisplayListPagination } from '../../../components/TapUi';

class ReminderHistoryTab extends AppBaseComponent {

    constructor(props) {
        super(props);

        this.state = {
            //dealData: props.dealData,
            reminder_listing: [],
            reminder_loading: false,
            reminderMeta: null,
            performAction: props.performAction && props.performAction === 'N' ? 'N' : 'Y',
            isDataFetched: false // Flag to track if data has been fetched
        }

        this.reminderListUrl = SCHEDULE_API_BASE_URL_2 + '/reminder/list';
        this.reminderDeleteUrl = SCHEDULE_API_BASE_URL_2 + '/reminder/delete';
    }

    componentDidMount() {
        // Don't fetch on mount - wait for tab click
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.dealData &&
            this.props.dealData.id !== prevProps.dealData?.id
        ) {
            this.setState({
                reminder_listing: [],
                reminderMeta: null,
                isDataFetched: false
            });
        }
    }

    // Method to be called when tab is clicked
    loadReminders = () => {
        if (this.props.dealData && this.props.dealData.id) {
           
            this.getReminderList(this.props.dealData.id);
        } else {
            
            toast.warning("No deal data available", { position: toast.POSITION.TOP_RIGHT });
        }
    }

    getReminderList = (dealId, page = 1) => {
        if (!dealId) {

            return;
        }

        this.setState({ reminder_loading: true });
        
        let params = {
            page: page,
            search_entity_key: 'deal_reminder',
            search_entity_id: this.props.dealData?.transaction_id
        };

      

        HttpAPICall.withAthorization(
            'GET', 
            this.reminderListUrl, 
            this.props.access_token, 
            params, 
            {},
            (response) => {
                let respData = response.data.data;

                let listingData = respData.data || [];
                
               
                let metaData = {
                    from: respData.from || 0,
                    to: respData.to || 0,
                    total: respData.total || 0,
                    last_page: respData.last_page || 1,
                    per_page: respData.per_page || 10,
                    current_page: respData.current_page || 1
                };

                this.setState({
                    reminder_listing: listingData,
                    reminderMeta: metaData,
                    isDataFetched: true,
                     reminderStatusList: response.data.status || [],
                }, () => {
                    console.log('Reminder state updated - Count:', this.state.reminder_listing.length);
                });
            },
            (error) => {
                console.error('Error fetching reminders:', error);
                toast.error(error?.msg || "Failed to load reminder history", { 
                    position: toast.POSITION.TOP_RIGHT 
                });
                this.setState({
                    reminder_listing: [],
                    reminderMeta: null,
                    isDataFetched: true
                });
            }
        ).then(() => {
            this.setState({ reminder_loading: false });
        });
    }

    deleteReminder = (reminderId) => {
        if (!reminderId) {
            toast.error("Invalid reminder ID", { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        swal({
            title: "Delete Reminder",
            text: "This action cannot be reversed. Are you sure you want to proceed?",
            icon: "warning",
            buttons: ["No", "Yes"],
            dangerMode: true,
        }).then(willDelete => {
            if (willDelete) {
                let payload = {
                    reminder_id: reminderId
                };

                console.log('Deleting reminder with ID:', reminderId);

                HttpAPICall.withAthorization(
                    'DELETE', 
                    this.reminderDeleteUrl + '/'    + reminderId, 
                    this.props.access_token, 
                    {}, 
                    payload,
                    (response) => {
                        console.log('Delete response:', response);
                        toast.success(response.data?.msg || "Reminder deleted successfully!", { 
                            position: toast.POSITION.TOP_RIGHT 
                        });
                        // Refresh the list after deletion
                        if (this.props.dealData && this.props.dealData.id) {
                            this.getReminderList(this.props.dealData.id);
                        }
                    },
                    (error) => {
                        console.error('Error deleting reminder:', error);
                        toast.error(error?.msg || "Failed to delete reminder", { 
                            position: toast.POSITION.TOP_RIGHT 
                        });
                    }
                );
            }
        });
    }

    reminderHistoryJsx = () => {
        let dealData = this.props.dealData;

        return (
            <>
                {dealData ? (
                    <>
                        <div className="tab_content_wrapper mt-2">
                            <span className="content_heading">Reminder History</span>
                            <span className="float-end">
                                {/* <button 
                                    className="btn btn-sm btn-primary"
                                    onClick={this.loadReminders}
                                    disabled={this.state.reminder_loading}
                                >
                                    <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className={this.state.reminder_loading ? 'fa-spin' : ''} /> 
                                    {this.state.reminder_loading ? ' Loading...' : ' Refresh'}
                                </button> */}
                            </span>
                        </div>
                        <table className="table table-hover table-bordered table-sm my-2">
                            <thead className="table-secondary">
                                <tr>
                                    <th scope="col" style={{ width: "5%" }}>S.no</th>
                                   <th scope="col" style={{ width: "12%" }}>Type</th>
                                    <th scope="col" style={{ width: "15%" }}>Date & Time</th>
                                    <th scope="col" style={{ width: "10%" }}>Status</th>
                                     <th scope="col" style={{ width: "12%" }}>Created At</th>
                                    {this.state.performAction === 'Y' && (
                                        <th scope="col" style={{ width: "5%" }}>Action</th>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.reminder_loading ? (
                                    <tr>
                                        <td className="text-center" colSpan={this.state.performAction === 'Y' ? 8 : 7}>
                                            <Loader />
                                        </td>
                                    </tr>
                                ) : this.state.reminder_listing && this.state.reminder_listing.length > 0 ? (
                                    this.state.reminder_listing.map((item, index) => {
                                        // Format date time
                                        let reminderDateTime = item.reminder_date_time;
                                        if (!reminderDateTime && item.start_date) {
                                            const hour = String(item.hour || 0).padStart(2, '0');
                                            const minutes = String(item.minutes || 0).padStart(2, '0');
                                            reminderDateTime = `${item.start_date} ${hour}:${minutes}:00`;
                                        }

                                      
                                        const statusObj = this.state.reminderStatusList.find(
                                            s => Number(s.key) === Number(item.status)
                                        );

                                        const statusDisplay = statusObj ? statusObj.status : "-";
                                        const statusColor = statusObj ? statusObj.color_code : "#6c757d";

                                        return (
                                            <tr key={item.id || index}>
                                                <td className="text-center">
                                                    {this.state.reminderMeta ? this.state.reminderMeta.from + index : index + 1}
                                                </td>
                                                
                                                <td>
                                                    {item.types && Array.isArray(item.types)
                                                        ? item.types.map((type, i) => (
                                                            <span key={i}>
                                                                {type.charAt(0).toUpperCase() + type.slice(1)}
                                                                {i < item.types.length - 1 ? ', ' : ''}
                                                            </span>
                                                        ))
                                                        : (
                                                            item.type
                                                                ? item.type.charAt(0).toUpperCase() + item.type.slice(1)
                                                                : item.reminder_type
                                                                    ? item.reminder_type.charAt(0).toUpperCase() + item.reminder_type.slice(1)
                                                                    : '-'
                                                        )}
                                                </td>
                                                <td>
                                                    {reminderDateTime ? DateService.dateTimeFormat(reminderDateTime, 'DD-MMM-YYYY HH:mm') : '-'}
                                                </td>
                                                <td>
                                                    <Status color={statusColor}>
                                                        {statusDisplay}
                                                    </Status>
                                                </td>
                                               
                                                <td>
                                                    {item.created_at ? DateService.dateTimeFormat(item.created_at, 'DD-MMM-YYYY HH:mm') : '-'}
                                                </td>
                                                {this.state.performAction === 'Y' && (
                                                    <td className="text-center">
                                                        <button
                                                            className="btn btn-link p-0 text-danger"
                                                            onClick={() => this.deleteReminder(item.id)}
                                                            title="Delete Reminder"
                                                            style={{ fontSize: '16px' }}
                                                        >
                                                            <TapIcon.FontAwesomeIcon icon={TapIcon.faTrashAlt} />
                                                        </button>
                                                    </td>
                                                )}
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td className="text-center" colSpan={this.state.performAction === 'Y' ? 8 : 7}>
                                            {this.state.isDataFetched ? 'No Reminders Found' : 'Click Refresh to load reminders'}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        {this.state.reminderMeta && this.state.reminderMeta.total > this.state.reminderMeta.per_page && (
                            <DisplayListPagination
                                meta={this.state.reminderMeta}
                                onPageChange={(e) => this.getReminderList(this.props.dealData?.id, e.selected + 1)}
                            />
                        )}
                    </>
                ) : (
                    <div className="text-center py-3">
                        <p>No deal data available</p>
                    </div>
                )}
            </>
        );
    }

    render() {
        return this.reminderHistoryJsx();
    }
}

const mapStateToProps = state => {
    return {
        access_token: state.auth.access_token,
    };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(ReminderHistoryTab);